import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ICheckListView, ICheckListViewData, ICheckListViewLabels } from "."

export interface IInitializeCheckListView {
    data: ICheckListViewData
    labels: ICheckListViewLabels
}

export const auditsSlice = createSlice({
    name: "audits",

    initialState: {
        data: {
            topics: [],
            questions: [],
        },
        topicExpansion: {},
        labels: {
            Actions: "",
            AddNewAction: "",
            AddNewFinding: "",
            ContextMenu: "",
            Findings: "",
            LinkExistingAction: "",
            LinkExistingFinding: "",
            NoQuestionsForTopic: "",
            NoData: "",
            Remark: "",
            RemarkPlaceholder: "",
        },
        isInitialized: false,
    } as ICheckListView,

    reducers: {
        initialize: (
            state,
            action: PayloadAction<IInitializeCheckListView>,
        ) => {
            const { labels, data } = action.payload
            if (!state.isInitialized) {
                state.labels = labels
                state.isInitialized = true
            }
            // in case of another field makes this one refresh via the fedback mechanism
            // the oldui.tsx's start method would be called multiple times
            // that case we need to reload only the data
            // the rest remains unchanged
            state.data = data
        },
        expand: (state, action: PayloadAction<string>) => {
            state.topicExpansion[action.payload] = true
        },
        collapse: (state, action: PayloadAction<string>) => {
            state.topicExpansion[action.payload] = false
        },
        loadData: (state, action: PayloadAction<ICheckListViewData>) => {
            state.data = action.payload
        },
    },
})

export default auditsSlice.reducer

export const { initialize, loadData, expand, collapse } = auditsSlice.actions
